export default {
    pollAssignment: null,
    pollResponseSuccessfullySaved: false,
    posting: false,
    redirectTo: null,
    selectedOptionId: null,
    showErrorAlert: false,
    status: null
};
